import { render, staticRenderFns } from "./index-active.vue?vue&type=template&id=3e34f8c5&scoped=true&"
import script from "./index-active.vue?vue&type=script&lang=js&"
export * from "./index-active.vue?vue&type=script&lang=js&"
import style0 from "./index-active.vue?vue&type=style&index=0&id=3e34f8c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e34f8c5",
  null
  
)

export default component.exports